// src/i18n/index.js
import React, { useState, useEffect } from 'react';
// src/i18n/index.js
import { translations } from './translations';

let currentLang = 'fr';
let listeners = [];

// Fonction pour obtenir une traduction
export const t = (key) => {
  if (!key) return '';
  
  const keys = key.split('.');
  let value = translations[currentLang];
  
  for (const k of keys) {
    if (value && value[k] !== undefined) {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return typeof value === 'string' ? value : key;
};

// Fonction pour changer la langue
export const changeLanguage = (lang) => {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem('ofd_lang', lang);
    document.documentElement.lang = lang;
    
    if (lang === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.classList.add('dir-rtl');
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.classList.remove('dir-rtl');
    }
    
    // Notifier tous les écouteurs
    listeners.forEach(listener => listener(lang));
    
    return true;
  }
  return false;
};

// Fonction pour obtenir la langue actuelle
export const getCurrentLanguage = () => currentLang;

// Initialisation de la langue
export const initLanguage = () => {
  const saved = localStorage.getItem('ofd_lang');
  if (saved && translations[saved]) {
    currentLang = saved;
  }
  document.documentElement.lang = currentLang;
  if (currentLang === 'ar') {
    document.documentElement.dir = 'rtl';
    document.documentElement.classList.add('dir-rtl');
  }
  return currentLang;
};

// Fonction pour s'abonner aux changements de langue
export const subscribe = (callback) => {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter(listener => listener !== callback);
  };
};

// Hook useTranslation
export const useTranslation = () => {
  const [lang, setLang] = React.useState(getCurrentLanguage());

  React.useEffect(() => {
    const unsubscribe = subscribe((newLang) => {
      setLang(newLang);
    });
    return unsubscribe;
  }, []);

  const changeLang = (newLang) => {
    changeLanguage(newLang);
  };

  return {
    t,
    lang,
    changeLanguage: changeLang
  };
};

// Exports pour compatibilité
export const getTranslation = t;
export const setLanguage = changeLanguage;